import React from "react";

export default function GoLiveCard({ gates }) {
  return (
    <div className="rounded-2xl border p-4 shadow-sm">
      <h3 className="text-lg font-semibold mb-3">Go-Live Checklist</h3>
      <ul className="space-y-1">
        {gates.map((g, i) => (
          <li key={i} className="flex items-center">
            <span
              className={`mr-2 h-2 w-2 rounded-full ${g.ok ? "bg-green-500" : "bg-yellow-500"}`}
            />
            <span className="text-sm">
              {g.label}
              {g.note ? ` — ${g.note}` : ""}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
